import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import qs from 'qs';

import {
    addBankAccountUrl,
    getBanksUrl,
    getCountryUrl,
    getStateUrl,
    uploadKycWithBVN
} from '../../shared/helpers/endPoints';
import {
    setBanks,
    setCountry,
    setError,
    setModal,
    setProcessLoading,
    setState,
    setSuccess,
    uploadKycWithBVNFailure,
    uploadKycWithBVNSuccess
} from './action';
import { fetchJSON } from '../../shared/helpers/apiCalls';
import { GET_BANKS, GET_COUNTRY, GET_STATE, UPDATE_BANK_ACCOUNT_DETAILS, UPLOAD_KYC_WITH_BVN } from './actionTypes';
import { getKycStatus } from '../bin/merchants/action';
import { toast } from 'react-toastify';
import { getStoreLocal } from '../../shared/helpers/utils';
import { authService, userService } from '../../modules/users/services/dependency.injection';
import { getKycTypes } from '../../modules/merchants/store/actions/action.creators';

function* callUpdateBankAccount({ payload: { value, merchant_id } }) {
    // token for all
    const token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'POST',
            url: addBankAccountUrl(modeType, merchant_id),
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
                'X-AUTH-PASSWORD': 'password'
            },
            data: JSON.stringify(value)
        };

        yield call(fetchJSON, options);

        yield put(setProcessLoading(false));
        yield put(setSuccess('You have successfully submitted bank details!!!'));
        yield put(getKycStatus(merchant_id));
        yield put(setModal({ bankModal: false }));
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.error;
        yield put(setProcessLoading(false));
        yield put(setError(message));
        yield put(setSuccess(''));
    }
}

function* callUploadKycWithBVN({ payload: { value, merchant_id } }) {
    // token for all
    const token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    // todo: uploadKycWithBVN --> In progress
    try {
        const options = {
            method: 'POST',
            url: uploadKycWithBVN(modeType, merchant_id),
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(value)
        };

        yield call(fetchJSON, options);

        yield put(uploadKycWithBVNSuccess());
        yield put(setSuccess('You have successfully submitted bank details!!!'));
        yield put(getKycStatus(merchant_id));
        yield put(getKycTypes(merchant_id))

        yield put(setModal({ bankModal: false }));

        toast.success('You have successfully submitted bank details!!!', {
            autoClose: 1000
        });
    } catch (error) {
        const result = error.data.error.message;

        let message = !!result ? result : 'Something went wrong please try again later';

        yield put(uploadKycWithBVNFailure(message));

        // yield put(setProcessLoading(false));
        // yield put(setError(message));
        // yield put(setSuccess(''));
    }
}

function* callGetBanks() {
    // token for all
    const token = userService.authService.getToken('client-token');
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            data: qs.stringify({ grant_type: 'client_credentials' }),
            params: { limit: 100000, offset: 0 },
            headers: {
                Authorization: `Bearer ${token}`
            },
            url: getBanksUrl(modeType)
        };

        const response = yield call(fetchJSON, options);
        yield put(setBanks(response.data));
        // set countries after a successful call
        // yield put(setCountry(response.data.content));
    } catch (error) {
        // let message = error === undefined ? 'Something went wrong please try again later' : error.data.message;
    }
}
function* callGetCountry() {
    // token for all
    const token = userService.authService.getToken('client-token');
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            data: qs.stringify({ grant_type: 'client_credentials' }),

            headers: {
                Authorization: `Bearer ${token}`
            },
            url: getCountryUrl(modeType)
        };

        const response = yield call(fetchJSON, options);

        // set countries after a successful call
        yield put(setCountry(response.data.content));
    } catch (error) {
        // let message = error === undefined ? 'Something went wrong please try again later' : error.data.message;
    }
}

function* callGetState({ payload: value }) {
    // token for all
    const token = userService.authService.getToken('client-token');
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            data: qs.stringify({ grant_type: 'client_credentials' }),

            headers: {
                Authorization: `Bearer ${token}`
            },
            url: getStateUrl(modeType, value)
        };

        const response = yield call(fetchJSON, options);
        yield put(setState(response.data));

        // set countries after a successful call
        // yield put(setState(response.data.content));
    } catch (error) {
        // let message = error === undefined ? 'Something went wrong please try again later' : error.data.message;
    }
}

export function* watchCallUpdateBankAccount() {
    yield takeEvery(UPDATE_BANK_ACCOUNT_DETAILS, callUpdateBankAccount);
}

export function* watchCallUploadKycWithBVN() {
    yield takeEvery(UPLOAD_KYC_WITH_BVN, callUploadKycWithBVN);
}

export function* watchCallGetBanks() {
    yield takeEvery(GET_BANKS, callGetBanks);
}
export function* watchCallGetCountry() {
    yield takeEvery(GET_COUNTRY, callGetCountry);
}
export function* watchCallGetState() {
    yield takeEvery(GET_STATE, callGetState);
}

function* utilsSaga() {
    yield all([
        fork(watchCallGetCountry),
        fork(watchCallGetState),
        fork(watchCallGetBanks),
        fork(watchCallUpdateBankAccount),
        fork(watchCallUploadKycWithBVN)
    ]);
}

export default utilsSaga;
